import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-grid-template',
  templateUrl: './grid-template.component.html',
  styleUrls: ['./grid-template.component.css']
})
export class GridTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
